export default __webpack_public_path__ + "static/media/icon_resurssit_lukittu.1d1a6ae7.svg";